import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ThemeCards = props => {
  let className = "theme-card-wrapper ";
  if (props.appliedTheme === props.theme.label) {
    className += "active ";
  }

  let themeClassname = "theme-card ";
  if (props.theme.label === "Default") {
    themeClassname += "default-theme ";
  }
  return (
    <div
      className={className}
      role="button"
      tabIndex={0}
      onClick={() => props.changeCoverpageTheme(props.theme.data)}
      onKeyPress={() => {}}>
      <div className={themeClassname}>
        <span className="selected-theme">
          <FontAwesomeIcon icon={["far", "check"]} />
        </span>
        <img src={props.theme.thumbnail} alt="" width="115" height="160" />
      </div>
      <span className="theme-card-title">{props.theme.label}</span>
    </div>
  );
};

export default ThemeCards;



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/CoverpageThemes/ThemeCards.js